export const getResourcesUrlToUse = (account: string) => {
  return `/landing/nxlambda/resources/${account}`;
};
